<template>
  <v-form v-model="loginForm.valid" ref="loginForm">
    <v-row>
      <v-col cols="12">
        <v-text-field
          @input="setVal"
          label="用户名"
          clearable
          v-model="loginForm.username"
          :rules="loginForm.usernameRules"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          @input="setVal"
          label="密码"
          type="password"
          clearable
          v-model="loginForm.password"
          :rules="loginForm.passwordRules"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          @input="setVal"
          label="验证码（不区分大小写）"
          clearable
          v-model="loginForm.loginCaptcha"
          :rules="loginForm.loginCaptchaRules.concat(validateLoginCaptcha)"
        ></v-text-field>
        <Captcha @setCaptchaNum="setCaptchaNum"></Captcha>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import Captcha from "../Captcha";
import api from "../../../http/apis/apis";
import { createNamespacedHelpers } from "vuex";
const {
  mapActions: userActions,
  mapState: userState,
  mapMutations: userMutations,
} = createNamespacedHelpers("user");
export default {
  props: ["loginForm"],
  data() {
    return {
      captchaStr: "",
    };
  },
  methods: {
    validateLoginCaptcha(val) {
      return val.toLowerCase() == this.captchaStr.toLowerCase() || "验证码错误";
    },
    setCaptchaNum(val) {
      this.captchaStr = val;
    },
    setVal() {
      this.$emit("setLoginValue", this.loginForm);
      this.$refs.loginForm.validate();
    },
  },
  components: {
    Captcha,
  },
};
</script>

<style>
</style>